import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Card from 'components/atoms/Cards/Card/Card';
import utils from 'helpers/utils';

const StyledKanbanPanel = styled(Card)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--kanban-panel-header-background-color': props.theme.property(`palette.${props.$color}.main`) ?? props.theme.property('palette.tagGroupDefault.dark'),
      '--kanban-panel-header-svg-color': props.theme.property('palette.white.main'),
      '--kanban-panel-header-svg-text-color': props.theme.property(`palette.${props.$color}.main`)
    };

    return utils.styleProps(attr, vars);
  })`
  border-radius: ${props => props.theme.radius(2)};
  
  .KanbanPanel {
    &-header {
      height: ${props => props.theme.layout(48)};
      color: ${props => props.theme.property('palette.white.main')};
      background-color: ${props => props.$css.$var('--kanban-panel-header-background-color')};
      .MuiCardHeader-title > * {
        display: flex;
        align-items: center;
        white-space: nowrap;
        
        .Icon {
          margin-right: ${props => props.theme.layout('1sp')};
        }
        svg {
          color: ${props => props.$css.$var('--kanban-panel-header-svg-color')};
          text {
            color: ${props => props.$css.$var('--kanban-panel-header-svg-text-color')};
          }
        }
      }
    }

    &-content {
      padding: ${props => props.theme.spacing(1)} ${props => props.theme.spacing(2)};
    }
  }
  ${ComponentStyles}
`;

StyledKanbanPanel.propTypes = {
  theme: PropTypes.object
};

export default StyledKanbanPanel;
